import styled, { css } from 'styled-components';

type ContainerProps = {
  isSidebarOpened: boolean;
};

export const Container = styled.div<ContainerProps>`
  width: ${(props) =>
    props.isSidebarOpened ? css`calc(100% - 28rem)` : css`calc(100% - 8rem)`};

  > div {
    padding: 2rem;
  }
`;

export const Page = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white_medium};
  border: 1px solid ${({ theme }) => theme.colors.gray_medium};
  padding: 2rem;

  display: flex;
  flex-direction: column;
`;
